import config from 'cfg';
import { requestAsync } from 'redux-query';
import get from 'lodash/get';
import { SOCIAL_NETWORKS, SMLINKS_BY_USER_ID, STORE_KEYS } from 'dash-front/constants';
import { createApiFetch } from 'dash-front/actions/helpers';
import auth from 'dash-front/auth';
import { httpMethods, UPDATE_DEFAULT } from '../../requery/actions';

const SOC_NETWORK_MAP = SOCIAL_NETWORKS.reduce((acc, cur) => {
    acc[cur.key] = cur.title;
    return acc;
}, {});

const getLinkTitle = link => SOC_NETWORK_MAP[link.smtype] || 'Unknown';

const transformSmlinks = links => {
    const array = links.map(link => ({
        title: getLinkTitle(link) + '. ' + link.name,
        ...link,
    }));
    const byId = array.reduce((acc, cur) => {
        acc[cur._id] = cur;
        return acc;
    }, {});
    return {
        [STORE_KEYS.SMLINKS]: array,
        [STORE_KEYS.SMLINKS + STORE_KEYS.BY_ID]: byId,
    };
};

export const fetchSmlinks = () => {
    const requestConfig = createApiFetch({
        url: `${SMLINKS_BY_USER_ID}?access_token=${auth.getAccessToken()}`,
        key: STORE_KEYS.SMLINKS,
        configOptions: {
            transform: transformSmlinks,
            update: {
                [STORE_KEYS.SMLINKS]: (prev, cur) => {
                    return cur;
                },
                [STORE_KEYS.SMLINKS + STORE_KEYS.BY_ID]: (prev, cur) => {
                    return { ...prev, ...cur };
                },
            },
        },
    });
    return requestAsync(requestConfig);
};

export const deleteSmlink = (id = '') => (dispatch, getState) => {
    return dispatch(
        requestAsync({
            url: `${config.apis.smpg}/unlink/${id}?access_token=${auth.getAccessToken()}`,
            update: {
                [STORE_KEYS.SMLINKS]: UPDATE_DEFAULT.LATEST,
            },
            transform: () => ({
                [STORE_KEYS.SMLINKS]: get(getState(), ['query', 'entities', STORE_KEYS.SMLINKS], []).filter(
                    ({ id: idLink }) => idLink !== id,
                ),
            }),
            list: () => ({
                [STORE_KEYS.SMLINKS]: get(getState(), ['query', 'entities', STORE_KEYS.SMLINKS], []).filter(
                    ({ id: idLink }) => idLink !== id,
                ),
            }),
            force: true,
            queryKey: 'DELETE:' + STORE_KEYS.SMLINKS,
            options: {
                method: httpMethods.DELETE,
            },
        }),
    );
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/actions/smlinks.js
 **/